import React, { Fragment } from 'react';
import {
  string,
  func,
  bool,
} from 'prop-types';
import classNames from 'classnames/bind';
import usStates from '../../../estimateBuilder/helpers/usStates';

const StatesDropDown = ({
  id, value, errorMessage, label, name, handleChange, handleOnBlur, disabled,
}) => {
  const inputClassName = (val, err) => classNames({ filled: val, error: err });

  return (
    <Fragment>
      <div className="gcc-dropdown">
        <select
          value={value}
          id={id}
          disabled={disabled}
          onChange={handleChange}
          onBlur={handleOnBlur}
          name={name}
          className={inputClassName(value, errorMessage)}
        >
          {usStates.map(option => (
            <option
              autoFocus // eslint-disable-line
              key={option.name}
              name={option.name}
              value={option.value}
            >
              {option.display || option.value}
            </option>
          ))}
        </select>
        <label htmlFor={id}>{label}</label>
      </div>
      { errorMessage && <span className="red f7 fw5" >{errorMessage}</span> }
    </Fragment>
  );
};

StatesDropDown.defaultProps = {
  id: '',
  value: null,
  label: '',
  name: '',
  errorMessage: '',
  disabled: false,
  handleChange: () => { },
  handleOnBlur: () => { },
};

StatesDropDown.propTypes = {
  id: string,
  value: string,
  label: string,
  name: string,
  errorMessage: string,
  disabled: bool,
  handleChange: func,
  handleOnBlur: func,
};

export default StatesDropDown;
